// collection tabbing start
const tabLinks = document.querySelectorAll(".ll--tab-link");
const tabContents = document.querySelectorAll(".ll--tab-content");

tabLinks.forEach((link) => {
  link.addEventListener("click", () => {
    // Remove active class from all links
    tabLinks.forEach((link) => link.classList.remove("active"));
    // Add active class to clicked link
    link.classList.add("active");

    // Hide all tab contents
    tabContents.forEach((content) => content.classList.remove("active"));

    // Show current tab content
    const targetTab = document.getElementById(link.dataset.tab);
    targetTab.classList.add("active");
  });
});
// collection tabbing End
// *****************************************************************
// announcement-bar-remove btn
// document.addEventListener("DOMContentLoaded", function () {
//   var buttons = document.querySelectorAll(".lm-no--btn");

//   buttons.forEach(function (button) {
//     button.addEventListener("click", function () {
//       var parentElement = this.closest(".announcement-bar-remove");
//       if (parentElement) {
//         parentElement.remove();
//       }
//     });
//   });
// });
// announcement-bar-remove btn end
// *****************************************************************
// key-highlights Start
document.addEventListener("DOMContentLoaded", () => {
  const cards = document.querySelectorAll(".ll--key-highlights-card");
  let currentIndex = 0;
  let intervalId = null;
  let isPaused = false;

  // Function to show the current card
  function showCard(index) {
    cards.forEach((card) => card.classList.remove("active")); // Hide all cards
    cards[index].classList.add("active"); // Show the active card
  }

  // Function to start the slider
  function startSlider() {
    isPaused = false; // Reset pause state
    intervalId = setInterval(() => {
      currentIndex = (currentIndex + 1) % cards.length; // Loop through cards
      showCard(currentIndex);
    }, 3000); // 3 seconds interval
  }

  // Function to stop the slider
  function stopSlider() {
    isPaused = true; // Set pause state
    clearInterval(intervalId);
  }

  // Function to initialize the slider for mobile screens
  function initializeMobileSlider() {
    if (window.innerWidth <= 768) {
      currentIndex = 0; // Reset the index
      showCard(currentIndex); // Show the first card
      startSlider(); // Start the slider

      // Add click/tap event listener to stop/resume the slider
      cards.forEach((card) => {
        card.addEventListener("click", () => {
          if (isPaused) {
            startSlider(); // Resume if paused
          } else {
            stopSlider(); // Pause if running
          }
        });
      });
    } else {
      // If not on mobile, reset styles to show all cards
      stopSlider(); // Stop any existing slider
      cards.forEach((card) => card.classList.remove("active"));
      cards.forEach((card) => (card.style.display = "flex"));
    }
  }

  // Initialize the slider
  initializeMobileSlider();

  // Reapply on window resize to ensure responsiveness
  window.addEventListener("resize", initializeMobileSlider);
});

// key-highlights End
// *****************************************************************
// Header handle the menu functionality start
document.addEventListener("DOMContentLoaded", () => {
  const menuDetails = document.querySelectorAll(
    ".menu-drawer__menu > li > details"
  );

  menuDetails.forEach((menuDetail) => {
    const summary = menuDetail.querySelector("summary");
    const submenu = menuDetail.querySelector(".menu-drawer__submenu");

    if (summary && submenu) {
      summary.addEventListener("click", (event) => {
        event.preventDefault();

        // Close other open menus
        menuDetails.forEach((otherMenu) => {
          if (otherMenu !== menuDetail && otherMenu.open) {
            otherMenu.open = false;
            const otherSummary = otherMenu.querySelector("summary");
            const otherSubmenu = otherMenu.querySelector(
              ".menu-drawer__submenu"
            );
            if (otherSummary && otherSubmenu) {
              otherSummary.setAttribute("aria-expanded", "false");
            }
          }
        });

        // Toggle the clicked menu
        const isOpen = menuDetail.open;
        menuDetail.open = !isOpen;
        summary.setAttribute("aria-expanded", !isOpen ? "true" : "false");
      });
    }

    // Handle close button inside submenu
    const closeButton = submenu.querySelector(".menu-drawer__close-button");
    if (closeButton) {
      closeButton.addEventListener("click", () => {
        menuDetail.open = false;
        summary.setAttribute("aria-expanded", "false");
      });
    }
  });

  document
    .querySelector(".ll-menu--close")
    .addEventListener("click", function () {
      document.body.classList.remove("overflow-hidden-tablet");
    });
});
// Header handle the menu functionality end

// *****************************************************************

// Toggle FAQ Answer and icons (Accordion behavior)
document.addEventListener("DOMContentLoaded", function () {
  const faqSections = document.querySelectorAll('.faq-tabs-section'); // Select all FAQ sections

  faqSections.forEach(section => {
    const faqQuestions = section.querySelectorAll('.faq-question');
    
    faqQuestions.forEach(question => {
      question.addEventListener('click', () => {
        const answer = question.nextElementSibling; // Assuming the answer follows the question
        const icon = question.querySelector('.toggle-icon');
        
        // Close all other answers (accordion effect)
        faqQuestions.forEach(otherQuestion => {
          if (otherQuestion !== question) {
            const otherAnswer = otherQuestion.nextElementSibling;
            otherAnswer.style.display = 'none'; // Hide all other answers
            otherQuestion.classList.remove('open'); // Remove open class from other questions
            const otherIcon = otherQuestion.querySelector('.toggle-icon');

            // Handle the other question's icon (show plus or chevron based on settings)
            if (section.dataset.showChevronIcon === "true") {
              otherIcon.innerHTML = `<span class="ll--svg-text">More Details</span> <svg aria-hidden="true" focusable="false" class="icon icon-chevron-down" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M5.29289 9.29289C5.68342 8.90237 6.31658 8.90237 6.70711 9.29289L12 14.5858L17.2929 9.29289C17.6834 8.90237 18.3166 8.90237 18.7071 9.29289C19.0976 9.68342 19.0976 10.3166 18.7071 10.7071L12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071L5.29289 10.7071C4.90237 10.3166 4.90237 9.68342 5.29289 9.29289Z" fill="currentcolor"/>
              </svg>`; // Show the chevron down icon
            } else {
              otherIcon.innerHTML = `<span class="ll--svg-text">More Details</span> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <path d="M12 4.5C12.5523 4.5 13 4.94772 13 5.5V11.5H19C19.5523 11.5 20 11.9477 20 12.5C20 13.0523 19.5523 13.5 19 13.5H13V19.5C13 20.0523 12.5523 20.5 12 20.5C11.4477 20.5 11 20.0523 11 19.5V13.5H5C4.44772 13.5 4 13.0523 4 12.5C4 11.9477 4.44772 11.5 5 11.5H11V5.5C11 4.94772 11.4477 4.5 12 4.5Z" fill="#0E0F0F"/>
              </svg>`; // Show the plus icon
            }
          }
        });

        // Toggle the clicked question's answer
        if (question.classList.contains('open')) {
          answer.style.display = 'none'; // Hide the answer if it's already open
          question.classList.remove('open'); // Remove the open class

          // Set icon back to plus or chevron when question is closed
          if (section.dataset.showChevronIcon === "true") {
            icon.innerHTML = `<span class="ll--svg-text">More Details</span> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
              <path d="M5.29289 9.29289C5.68342 8.90237 6.31658 8.90237 6.70711 9.29289L12 14.5858L17.2929 9.29289C17.6834 8.90237 18.3166 8.90237 18.7071 9.29289C19.0976 9.68342 19.0976 10.3166 18.7071 10.7071L12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071L5.29289 10.7071C4.90237 10.3166 4.90237 9.68342 5.29289 9.29289Z" fill="currentcolor"/>
            </svg>`; // Show the chevron down icon
          } else {
            icon.innerHTML = `<span class="ll--svg-text">More Details</span> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
              <path d="M12 4.5C12.5523 4.5 13 4.94772 13 5.5V11.5H19C19.5523 11.5 20 11.9477 20 12.5C20 13.0523 19.5523 13.5 19 13.5H13V19.5C13 20.0523 12.5523 20.5 12 20.5C11.4477 20.5 11 20.0523 11 19.5V13.5H5C4.44772 13.5 4 13.0523 4 12.5C4 11.9477 4.44772 11.5 5 11.5H11V5.5C11 4.94772 11.4477 4.5 12 4.5Z" fill="#0E0F0F"/>
            </svg>`; // Show the plus icon
          }
        } else {
          answer.style.display = 'block'; // Show the answer
          question.classList.add('open'); // Add the open class

          // Change icon to minus when the question is open
          if (section.dataset.showChevronIcon === "true") {
            icon.innerHTML = `<span class="ll--svg-text">More Details</span> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
              <path d="M11.2929 7.79289C11.6834 7.40237 12.3166 7.40237 12.7071 7.79289L18.7071 13.7929C19.0976 14.1834 19.0976 14.8166 18.7071 15.2071C18.3166 15.5976 17.6834 15.5976 17.2929 15.2071L12 9.91421L6.70711 15.2071C6.31658 15.5976 5.68342 15.5976 5.29289 15.2071C4.90237 14.8166 4.90237 14.1834 5.29289 13.7929L11.2929 7.79289Z" fill="white"/>
            </svg>`; // Show the chevron up icon
          } else {
            icon.innerHTML = `<span class="ll--svg-text">More Details</span> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
              <path d="M4 12.5C4 11.9477 4.44772 11.5 5 11.5H19C19.5523 11.5 20 11.9477 20 12.5C20 13.0523 19.5523 13.5 19 13.5H5C4.44772 13.5 4 13.0523 4 12.5Z" fill="white"/>
            </svg>`; // Show the minus icon
          }
        }
      });
    });
  });
});


// *****************************************************************
// Copy Discount Code Start

  function copyDiscountCode() {
    // Get the discount code element
    const discountCodeElement = document.querySelector('.ll--discount-bold-code');
    
    if (discountCodeElement) {
      // Get the text content
      const discountCode = discountCodeElement.textContent;

      // Copy the text to the clipboard
      navigator.clipboard.writeText(discountCode).then(() => {
        console.log('Discount code copied: ' + discountCode);
      }).catch(err => {
        console.error('Failed to copy text: ', err);
      });
    }
  }

// Copy Discount Code End

// *****************************************************************

document.addEventListener("DOMContentLoaded", () => {
  const stickyElement = document.querySelector(".hw__product-tab--sticky");
  let lastScrollTop = window.scrollY;
if (stickyElement){
  window.addEventListener("scroll", () => {
    const currentScrollTop = window.scrollY;

    if (currentScrollTop > lastScrollTop) {
      // Scrolling down
      stickyElement.classList.remove("scroll-up");
      stickyElement.classList.add("scroll-down");
    } else if (currentScrollTop < lastScrollTop) {
      // Scrolling up
      stickyElement.classList.remove("scroll-down");
      stickyElement.classList.add("scroll-up");
    }

    lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // Avoid negative values
  });
}
});

// *****************************************************************

document.addEventListener("DOMContentLoaded", function () {
  const description = document.querySelector(".product__description");
  const readMoreBtn = document.querySelector(".read-more-btn");
  const readLessBtn = document.querySelector(".read-less-btn");

  // Initially hide the Read Less button
  if(readLessBtn) {
   readLessBtn.style.display = "none"; 
  }

  // Read More button functionality
  readMoreBtn.addEventListener("click", function () {
    description.classList.add("expanded"); // Show full content
    readMoreBtn.style.display = "none"; // Hide Read More button
    readLessBtn.style.display = "flex"; // Show Read Less button
  });

  // Read Less button functionality
  readLessBtn.addEventListener("click", function () {
    description.classList.remove("expanded"); // Hide extra content
    readMoreBtn.style.display = "flex"; // Show Read More button
    readLessBtn.style.display = "none"; // Hide Read Less button
  });
});


// *****************************************************************

       // Hamburger Menu Toggle
        function toggleHamburger() {
            const sidebar = document.querySelector('.sidebar'); // Ensure this exists
            const icons = document.querySelectorAll('.hamburger-menu, .close-icon'); // Returns a NodeList

            // Destructure the NodeList into individual elements
            const [hamburgerMenu, closeIcon] = icons;

            // Check if elements exist to avoid runtime errors
            if (!sidebar || !hamburgerMenu || !closeIcon) {
                console.error('Required elements not found.');
                return;
            }

            sidebar.classList.toggle('sidebar-hidden');

            // Toggle the visibility of hamburger and close icons
            if (sidebar.classList.contains('sidebar-hidden')) {
                hamburgerMenu.style.display = 'block';
                closeIcon.style.display = 'none';
            } else {
                hamburgerMenu.style.display = 'none';
                closeIcon.style.display = 'block';
            }
        }



        // Tab Switching with Sidebar Close
        function showTab(tabId) {
            // Hide all tabs
            document.querySelectorAll('.tab-content').forEach(tab => tab.classList.remove('active'));

            // Deactivate all menu items
            document.querySelectorAll('.menu li a').forEach(link => link.classList.remove('active'));

            // Show the selected tab
            document.querySelectorAll(`#${tabId}`).forEach(tab => tab.classList.add('active'));

            // Activate the selected menu item
            document.querySelectorAll(`.menu li a[onclick="showTab('${tabId}')"]`).forEach(link => link.classList.add('active'));

            // Automatically close the sidebar (hamburger menu)
            toggleHamburger();
        }

// *****************************************************************
document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth <= 749) {
    // Select the container and its first h6 and p elements
    const container = document.querySelector('.product__description.rte.quick-add-hidden');
    const firstHeading = container.querySelector('h6');
    const firstParagraph = container.querySelector('p');

    if (container && firstHeading && firstParagraph) {
      // Get the computed height of the elements
      const headingHeight = firstHeading.offsetHeight;
      const paragraphHeight = firstParagraph.offsetHeight;

      // Calculate the total height
      const totalHeight = headingHeight + paragraphHeight + 5;

      // Set the total height as the max-height for the container
      container.style.maxHeight = `${totalHeight}px`;
    } else {
      console.log("Container, Heading, or Paragraph not found!");
    }
  }
});

// *****************************************************************
// Read More by Row Count Strat
// document.addEventListener("DOMContentLoaded", function () {
//   const readMoreButtons = document.querySelectorAll(".read-more");

//   const svgReadMore = `
//     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
//       <path d="M5.29289 9.29289C5.68342 8.90237 6.31658 8.90237 6.70711 9.29289L12 14.5858L17.2929 9.29289C17.6834 8.90237 18.3166 8.90237 18.7071 9.29289C19.0976 9.68342 19.0976 10.3166 18.7071 10.7071L12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071L5.29289 10.7071C4.90237 10.3166 4.90237 9.68342 5.29289 9.29289Z" fill="currentColor"/>
//     </svg>
//   `;

//   const svgReadLess = `
//     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
//       <path d="M11.2929 7.29289C11.6834 6.90237 12.3166 6.90237 12.7071 7.29289L18.7071 13.2929C19.0976 13.6834 19.0976 14.3166 18.7071 14.7071C18.3166 15.0976 17.6834 15.0976 17.2929 14.7071L12 9.41421L6.70711 14.7071C6.31658 15.0976 5.68342 15.0976 5.29289 14.7071C4.90237 14.3166 4.90237 13.6834 5.29289 13.2929L11.2929 7.29289Z" fill="currentColor"/>
//     </svg>
//   `;

//   function countTextRows(textElement) {
//     const computedStyle = window.getComputedStyle(textElement);
//     const textHeight = textElement.scrollHeight;
//     const lineHeight = parseFloat(computedStyle.lineHeight);
//     const numberOfRows = Math.round(textHeight / lineHeight);
//     return numberOfRows;
//   }

//   function updateButtonVisibility() {
//     readMoreButtons.forEach((button) => {
//       const content = button
//         .closest(".read-more-content")
//         .querySelector(".read-more-content p");
//       const rows = countTextRows(content);

//       rows <= 2
//         ? button.classList.add("hidden")
//         : button.classList.remove("hidden");
//     });
//   }

//   readMoreButtons.forEach((button) => {
//     const content = button
//       .closest(".read-more-content")
//       .querySelector(".read-more-content p");

//     // Initialize with Read More SVG and class
//     button.innerHTML = `Read More ${svgReadMore}`;
//     button.classList.add("read-more-btn");

//     button.addEventListener("click", function () {
//       content.classList.toggle("expanded");

//       if (content.classList.contains("expanded")) {
//         button.innerHTML = `Read Less ${svgReadLess}`;
//         button.classList.add("read-less-btn");
//         button.classList.remove("read-more-btn");
//       } else {
//         button.innerHTML = `Read More ${svgReadMore}`;
//         button.classList.add("read-more-btn");
//         button.classList.remove("read-less-btn");
//       }
//     });
//   });

//   updateButtonVisibility();

//   window.addEventListener("resize", function () {
//     updateButtonVisibility();
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  const readMoreButtons = document.querySelectorAll(".read-more");

  const svgReadMore = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M5.29289 9.29289C5.68342 8.90237 6.31658 8.90237 6.70711 9.29289L12 14.5858L17.2929 9.29289C17.6834 8.90237 18.3166 8.90237 18.7071 9.29289C19.0976 9.68342 19.0976 10.3166 18.7071 10.7071L12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071L5.29289 10.7071C4.90237 10.3166 4.90237 9.68342 5.29289 9.29289Z" fill="currentColor"/>
    </svg>
  `;

  const svgReadLess = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M11.2929 7.29289C11.6834 6.90237 12.3166 6.90237 12.7071 7.29289L18.7071 13.2929C19.0976 13.6834 19.0976 14.3166 18.7071 14.7071C18.3166 15.0976 17.6834 15.0976 17.2929 14.7071L12 9.41421L6.70711 14.7071C6.31658 15.0976 5.68342 15.0976 5.29289 14.7071C4.90237 14.3166 4.90237 13.68342 5.29289 13.2929L11.2929 7.29289Z" fill="currentColor"/>
    </svg>
  `;

  readMoreButtons.forEach((button) => {
      const content = button.previousElementSibling; // Selecting `.collection-description`
  
      if (!content) return;

    if (!content.classList.contains('product__description')) {
      // Initial setup for truncated content
      content.style.display = "-webkit-box";
      content.style.webkitLineClamp = "2";
      content.style.overflow = "hidden";
      content.style.webkitBoxOrient = "vertical";

    button.innerHTML = `Read More ${svgReadMore}`;

    button.addEventListener("click", function () {
      content.classList.toggle("expanded");

      if (content.classList.contains("expanded")) {
        content.style.display = "block";
        content.style.webkitLineClamp = "unset";
        button.innerHTML = `Read Less ${svgReadLess}`;
      } else {
        content.style.display = "-webkit-box";
        content.style.webkitLineClamp = "2";
        button.innerHTML = `Read More ${svgReadMore}`;
      }
    });
    }
  });
});
// Read More by Row Count End
// *****************************************************************
